import InactivityIntervalsListPage from './InactivityIntervalsListPage.vue';
import InactivityIntervalsListTable from './InactivityIntervalsListTable.vue';

export * from './types';

export {
    InactivityIntervalsListPage as default,
    InactivityIntervalsListPage,
    InactivityIntervalsListTable
};
